import { FormControl, FormLabel, RadioGroup } from '@mui/material';
import { forwardRef } from 'react';

import type { FormControlProps, FormLabelProps } from '@mui/material';
import type { RadioGroupProps } from '@mui/material/RadioGroup/RadioGroup';
import type React from 'react';
import type { FC } from 'react';

export interface RadioGroupFieldProps
  extends
    Omit<FormControlProps, 'onChange' | 'ref'>,
    Pick<FormLabelProps, 'defaultValue' | 'id' | 'filled'>,
    Omit<RadioGroupProps, 'classes' | 'className' | 'color' | 'defaultValue'>
{
  component?: React.ElementType;
  label?: React.ReactNode;
}

export const RadioGroupField: FC<RadioGroupFieldProps> = forwardRef( function RadioGroupField({
  /* FormControlProps */
  error,
  required,
  classes,
  variant,
  color,
  focused,
  disabled,
  fullWidth,
  hiddenLabel,
  margin,
  size,
  sx,
  style,
  className,
  component,

  /* FormLabelProps */
  defaultValue,
  id,
  filled,
  label,

  /* RadioGroupProps */
  'aria-labelledby': ariaLabeldBy,
  name,
  children,

  ...props
}, ref) {
  return (
    <FormControl
      ref={ref}
      error={error}
      required={required}
      classes={classes}
      variant={variant}
      color={color}
      focused={focused}
      disabled={disabled}
      sx={sx}
      fullWidth={fullWidth}
      hiddenLabel={hiddenLabel}
      margin={margin}
      size={size}
      style={style}
      className={className}
      component={component ?? 'div'}
    >
      <FormLabel
        required={required}
        disabled={disabled}
        focused={focused}
        error={error}
        color={color}
        defaultValue={defaultValue}
        id={id}
        filled={filled}
      >
        {label}
      </FormLabel>
      <RadioGroup
        color={color}
        // defaultValue={defaultValue}
        aria-labelledby={ariaLabeldBy}
        name={name}
        {...props}
      >
        {children}
      </RadioGroup>
    </FormControl>
  );
} );
